export default "__VITE_ASSET__DgvRqLug__"